<script>
  import CornerIcon from '$icons/CornerIcon.svelte';
  export let isRead = false;
</script>

<div class="relative flex h-8 w-8 items-center justify-center">
  <div class:text-mint-dark-11={!isRead} class="text-gray-dark-8 z-10">
    <CornerIcon class=" absolute left-0 top-0 h-1 w-1 -rotate-90" />
    <CornerIcon class=" absolute right-0 top-0 h-1 w-1 " />
    <CornerIcon class=" absolute bottom-0 left-0 h-1 w-1 rotate-180" />
    <CornerIcon class=" absolute bottom-0 right-0 h-1 w-1 rotate-90" />
    <slot />
  </div>
  <div class="absolute inset-0 flex flex-col justify-between">
    {#each Array(10) as _}
      <div class="bg-gray-dark-4 h-px w-full"></div>
    {/each}
  </div>
</div>
